import React from 'react';
type Ratio = '21/9' | '16/9' | '4/3' | '3/2' | '1/1' | 'auto';
type MediaProps = {
  src: string;
  /** Empty string marks the image decorative and hides it from assistive tech. */
  alt: string;
  caption?: string;
  ratio?: Ratio;
  /** Contain the image inside a padded plate — for logo lockups and devices. */
  contain?: boolean;
  /** Plate colour behind a contained image (a client's brand colour). */
  plate?: string;
  className?: string;
  priority?: boolean;
};

/** The single framed-media component: hairline frame, fixed ratio, label caption. */
export function Media({
  src,
  alt,
  caption,
  ratio = 'auto',
  contain = false,
  plate,
  className = '',
  priority = false
}: MediaProps) {
  const decorative = alt === '';
  return <figure className={className} data-id="element-252" data-mp="1qjaedll7bivw">
      <div className="frame flex items-center justify-center" style={{
      aspectRatio: ratio === 'auto' ? undefined : ratio.replace('/', ' / '),
      background: plate,
      padding: contain ? 'clamp(20px, 4vw, 48px)' : undefined
    }} data-id="element-253" data-mp="t2trdpbxpw0c">
        <img src={src} alt={decorative ? '' : alt} aria-hidden={decorative || undefined} loading={priority ? 'eager' : 'lazy'} className={contain ? 'block h-auto max-h-full w-auto max-w-full object-contain' : ratio === 'auto' ? 'block h-auto w-full' : 'block h-full w-full object-cover object-top'} data-id="element-254" data-mp="5kfbwn90jfas" />
      </div>
      {caption && <figcaption className="t-label mt-4 text-subtle" data-id="element-255" data-mp="3dx30zg78tcsy">{caption}</figcaption>}
    </figure>;
}